import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export const useMember = defineStore('member', {
  state: () => ({}),
  actions: {
    // 人员列表
    async getStaffList(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/user/page',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 人员详情
    async getStaffInfo(id: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/user/info/${id}`,
          method: 'get'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增人员
    async addStaffList(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/user/create',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 更新人员
    async postStaffUpdate(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/user/update',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 冻结/解冻人员
    async postStaffFreeze(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/user/changeFreeze',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 重置密码
    async resetPwd(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/user/resetPwd/${(data as any).userId}`,
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 角色名称标签列表
    async getNameTag() {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/role/nameTag',
          method: 'get'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取微区域站点树
    async getMicroAreaSiteTreeByArea(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/area/getMicroAreaSiteTreeByArea',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取区域微树
    async getAreaMicroTree(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/role/getAreaMicroTree',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取字典
    async getDict(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dataDict/dict',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 修改手机号
    async changeTel(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/user/changeTel',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 导入人员数据
    async staffImportData(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/user/importData',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 导入分页数据
    async staffImportPageData(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/user/importPage',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
